// extracted by css-extract-rspack-plugin
export default {"editorContainer":"CqCJm","editor":"l40Th","sidebar":"mO7Sn","flexStart":"_F0tt"};